import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import CreateSaq from "../../components/CreateSaq";

import { images } from "../../helpers/images";
import { onClickBusinessSignup } from "../../modules/actions/";

import {
  callApiSaqsFind,
  callApiUsersList,
  callApiBusinessesList,
  callApiWhiteLabelBusinessesList,
} from "../../services";
import { authUserData } from "../../helpers";
import SaqLists from "../../components/SaqLists";
import Header from "../../components/Header";

class CreateCompany extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      purpose: "white-label-signup",
      userType: "admin",
      businessSourceId: "",
      businessType: "",
      email: "",
      password: "",
      confirmPassword: "",
      secretCode: "fds235&*",
      disableLogin: false,
      showRegister: true,
      businessName: "",
      website: "",
      subdomain: "",
      whiteLabelBusinessList: [],
    };
  }

  onChangeHandelUserInput = async (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;

    this.setState({
      [name]: value,
    });
  };

  onClickSignup = async () => {
    this.setState({ disableLogin: true });
    const businessSignupPayload = {
      purpose: this.state.purpose,
      userType: this.state.userType,
      businessSourceId: this.state.businessSourceId,
      businessType: this.state.businessType,
      email: this.state.email,
      password: this.state.password,
      confirmPassword: this.state.confirmPassword,
      businessName: this.state.businessName,
      website: this.state.website,
      subdomain: this.state.subdomain,
      secretCode: this.state.secretCode,
      logo: "",
    };
    console.log("businessSignupPayload", businessSignupPayload);
    const status = await this.props.onClickBusinessSignup(
      businessSignupPayload
    );

    console.log("status", status);

    if (status === true) {
      setTimeout(
        () =>
          this.setState({
            purpose: "",
            userType: "",
            businessSourceId: "",
            businessType: "",
            email: "",
            password: "",
            confirmPassword: "",
            businessName: "",
            website: "",
            subdomain: "",
            secretCode: "",
            logo: "",
            disableLogin: false,
          }),
        2500
      );
    } else {
      this.setState({
        disableLogin: false,
      });
    }
  };

  onTextKeyPress = (evt) => {
    if (evt.key === "Enter") {
      this.onClickSignin(evt);
    }
  };

  render() {
    const { history } = this.props;
    const {
      purpose,
      userType,
      businessType,
      email,
      password,
      confirmPassword,
      secretCode,
      disableLogin,
      showRegister,
      businessName,
      website,
      subdomain,
      businessSourceId,
      whiteLabelBusinessList,
    } = this.state;

    return (
      <>
        <ToastContainer />
        <div className="cell small-12 medium-10" id="maincontent">
          <Header />
          <div id="body-content">
            <div className="grid-x grid-margin-x grid-margin-y">
              <div className="cell small-12 medium-12" id="completedsaqs">
                <div className="module-header">
                  <h3>Create Company</h3>
                  <Link to="/control-panel/companies">
                    <button className="button nxt-btn">Companies</button>
                  </Link>
                </div>
                <div id="compltedsaqs-table">
                  <div className="grid-container">
                    <div className="grid-x grid-margin-x align-center">
                      <div className="small-12 medium-8 cell">
                        <label>Email</label>
                        <input
                          type="email"
                          placeholder="Enter email"
                          name="email"
                          value={email}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </div>
                      <div className="small-12 medium-8 cell">
                        <label>Password</label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Enter password"
                          name="password"
                          value={password}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </div>

                      <div className="small-12 medium-8 cell">
                        <label>Confirm Password</label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Enter confirm password"
                          name="confirmPassword"
                          value={confirmPassword}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </div>

                      <div className="small-12 medium-8 cell">
                        <label>Business Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter business name"
                          name="businessName"
                          value={businessName}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </div>

                      <div className="small-12 medium-8 cell">
                        <label>Website</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter website"
                          name="website"
                          value={website}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </div>

                      <div className="small-12 medium-8 cell">
                        <label>Subdomain</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter subdomain"
                          name="subdomain"
                          value={subdomain}
                          onChange={(evt) => this.onChangeHandelUserInput(evt)}
                          onKeyPress={(evt) => this.onTextKeyPress(evt)}
                        />
                      </div>
                    </div>
                    <div className="grid-x grid-margin-x align-center">
                      <div
                        className="small-12 medium-8 cell"
                        style={{ textAlign: "right" }}
                      >
                        <button
                          className="button prev-btn"
                          onClick={() =>
                            history.push("/control-panel/companies")
                          }
                          disabled={disableLogin}
                          style={{ color: "#000", marginRight: "25px" }}
                        >
                          Cancel
                        </button>
                        <button
                          className="button nxt-btn"
                          onClick={() => this.onClickSignup()}
                          disabled={disableLogin}
                        >
                          Sign up
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ onClickBusinessSignup }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCompany);
